import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  navigate() {
    const url = this.element.value
    if (url) {
      const frame = document.getElementById("de_retour_form")
      frame.src = url
    }
  }
}
